module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1 sgc-1"
  }, [_vm._v("\n    On a loud and sweltering city day, in a Catholic church on a downtown street, heavy wooden doors close out the traffic noise. Here are cool shadows and silence and stone, tile painted by the fall of light through stained glass. On the walls, Christ’s passion and death play out again in plaster, while in banked rows of votives, scattered candles flicker with the intentions of the prayerful. A confessional door opens and an old man comes out. Above his head a red light blinks to green. In the nearest pew, a young man of thirty or so—blue-eyed, slope-shouldered, curly-haired—glances around, then unfolds big-knuckled fists and stands. He wears a pair of paint-spattered jeans and a light blue sport shirt that matches his eyes and is open at the neck. The man enters the confessional, and the door clicks shut on the ritual words: “Bless me, Father, for I have sinned.”\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d83b6f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/john_9781571318169_oeb_fm1_r1.vue
// module id = 72
// module chunks = 0